export const myTaxTranslationsHu = {
  MY_TAX_FAMILY_TAX_APPLICATION_INFO: "Amennyiben a 2-es pontban bejelölt szerint a családi kedvezményt egyedül veszi igénybe, a nyilatkozat mentésekor, illetve nyomtatásakor a házastárs/élettárs adatai ennek megfelelően nem lesznek kitöltve. Biztosan folytatja?",
  MY_TAX_DECLARATION_REMOVED_FAILED: "Hiba történt a nyilatkozat visszavonása közben",
  MY_TAX_DECLARATION_REMOVED_SUCCESSFULLY: "A nyilatkozat sikeresen visszavonva",
  MY_TAX_MODIFIED_DECLARATION: "módosító nyilatkozat",
  MY_TAX_PREVIOUS_TAX_DECLARATION_DELETED: "A korábban beadott nyilatkozata törlésre került!",
  MY_TAX_APPLICATION_SAVE_FAILED: "Hiba történt a nyilatkozat mentése közben.",
  MY_TAX_INVALID: "Érvénytelen",
  MY_TAX_MODIFIED_APPLICATION: "Módosított nyilatkozat",
  MY_TAX_MODIFIER_APPLICATION: "Módosító nyilatkozat",
  MY_TAX_DECLARATION_CREATED_FAILED: "A nyilatkozat mentése nem sikerült",
  MY_TAX_DECLARATION_CREATED_SUCCESSFULLY: "A nyilatkozat mentése sikeresen megtörtént",
  MY_TAX_TAXDECLARATIONFAMILY: "Adóelőleg-nyilatkozat a családi kedvezmény és járulékkedvezmény érvényesítéséről",
  MY_TAX_TAXDECARATIONMOTHERUNDER30: "Adóelőleg-nyilatkozat a 30 év alatti anyák kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONFIRSTMARRIEDPERSON: "Adóelőleg-nyilatkozat az első házasok kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONUNDER25: "Nyilatkozat a 25 év alatti fiatalok kedvezményének részben vagy egészben történő érvényesítésének mellőzéséről",
  MY_TAX_TAXDECLARATIONELIGIBLECOSTS: "Adóelőleg-nyilatkozat az adóelőleg meghatározásakor figyelembe vehető költségekről",
  MY_TAX_TAXDECLARATIONPERSONAL: "Adóelőleg-nyilatkozat a személyi kedvezmény érvényesítéséről",
  MY_TAX_TAXDECLARATIONFOURCHILDREN: "Adóelőleg-nyilatkozat a négy vagy több gyermek után járó adókedvezmény érvényesítéséről",
  MY_TAX_STATE_K: "Beadva",
  MY_TAX_STATE_E: "Elfogadva",
  MY_TAX_STATE_T: "Érvénytelen",
  MY_TAX_STATE_V: "Elutasítva",
  MY_TAX_SUBMITTED_APPLICATIONS: "Beadott nyilatkozatok",
  MY_TAX_CREDIT_REQUEST_CREATED_AT: "Beadás időpontja",
  MY_TAX_AVAILABLE_APPLICATIONS: "Beadható nyilatkozat",
  MY_TAX_MY_APPLICATIONS: "Nyilatkozataim",
  MY_TAX_TAX_CREDIT_APPLICATIONS_SETTING_INFO: "Az adónyilatkozat tartalma mentésre kerül a JDolBer Humánügyviteli rendszerben.",
  MY_TAX_CREDIT_APPLICATIONS: "Adónyilatkozatok",
  MY_TAX_APPLICATIONS_MENU_INFO: "Az adónyilatkozatok megjelenítése",
  MY_TAX_TO_APPLICATIONS: "Tovább a kérelmekhez",
  MY_TAX_PLEASE_SELECT: "Kérem válasszon",
  MY_TAX_TAX_CREDIT_MONTH: "Hó",
  MY_TAX_TAXDECLARATIONTHREECHILDREN: "Adóelőleg-nyilatkozat a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONCOMBINED: "Összevont adóelőleg-nyilatkozat a családi kedvezmény és a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről"
};
